import { all, fork } from 'redux-saga/effects';

import { deposit } from './deposit/actions';
import { pending } from './pending/actions';
import { withdrawals } from './withdrawals/actions';

export function* fiatTransfer() {
  yield all([fork(deposit), fork(pending), fork(withdrawals)]);
}
